const navigationRoutes = {
  LOGIN: "/login",
  EDIT_PROPERTY: "/edit-property/:id",
  EDIT_COMPARISON_PROPERTY: "/edit-comparison-property/:id",
  CREATE_PROPERTY: "/create-property",
  CREATE_REHAB_ESTIMATOR: "/create-rehab-estimator",
  MAX_BID_CALCULATION: "/max-bid-calculation",
  MAX_BID_CALCULATION_TABLE: "/max-bid-calculation-table",
  PROPERTY_MASTER: "/property-master",
  COMPARISON_PROPERTY_MASTER: "/comparison-property-master",
  CREATE_COMPARISON_PROPERTY: "/create-comparison-property",
  REHAB_ESTIMATOR: "/rehab-estimator",
  COMPARISON_CALCULATION: "/comparison-calculation",
  REPORTS: "/reports",
  MY_PROPERTY: "/my-property",
  DASHBOARD: "/dashboard",
  NOT_FOUND: "*",
  EDIT_MAX_BID_CALCULATION: "/edit-max-bid-calculation/:id",
  EDIT_REHAB_ESTIMATOR: "/edit-rehab-estimator/:id",
  EDIT_MY_PROPERTY: "/edit-my-property/:id",
  IMPORT_PROPERTY: "/import-property",
  IMPORTANT_WEBSITE: "/important-website",
};

export default navigationRoutes;
